"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleModalComponent = exports.EModalFeedbackState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_fela_1 = require("react-fela");
const fi_1 = require("react-icons/fi");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaButton_1 = require("../fela/FelaButton");
const FelaCommon_1 = require("../fela/FelaCommon");
const FelaIconWrap_1 = require("../fela/FelaIconWrap");
const FelaLayers_1 = require("../fela/FelaLayers");
const FelaText_1 = require("../fela/FelaText");
var EModalFeedbackState;
(function (EModalFeedbackState) {
    EModalFeedbackState["NONE"] = "NONE";
    EModalFeedbackState["LOADING"] = "LOADING";
    EModalFeedbackState["ERROR"] = "ERROR";
    EModalFeedbackState["ALERT"] = "ALERT";
    EModalFeedbackState["CONFIRMATION"] = "CONFIRMATION";
})(EModalFeedbackState || (exports.EModalFeedbackState = EModalFeedbackState = {}));
const SimpleModalComponent = ({ onClose, message, style, className, cssExtra = [], feedbackState, customHeader, isFloating = true, buttonText, cancelText, }) => {
    const { theme } = (0, react_fela_1.useFela)();
    // const delayedState = useRef<{
    //   message: string;
    //   feedbackState: EModalFeedbackState | null;
    // }>({ message: "", feedbackState: null });
    const { color, header, buttonSection } = (0, react_1.useMemo)(() => {
        if (feedbackState === EModalFeedbackState.ERROR) {
            return {
                color: theme.styles.Colors.neutral.error,
                header: `An error occurred`,
                buttonSection: ((0, jsx_runtime_1.jsx)(FelaLayers_1.FelaFlexLayer, { align: "flex-end", justify: "flex-end", height: FelaLayers_1.EFelaLayerHeight.MID, padding: "0.75em", children: (0, jsx_runtime_1.jsx)(FelaButton_1.FelaButton, { onClick: () => {
                            // delayedState.current.message = message;
                            // delayedState.current.feedbackState = EModalFeedbackState.ERROR;
                            if (onClose) {
                                onClose(EModalFeedbackState.ERROR, true);
                            }
                        }, margin: "0", color: theme.styles.Colors.neutral.error, children: (0, jsx_runtime_1.jsx)("span", { className: "text", children: buttonText ?? "Continue" }) }) })),
            };
        }
        else if (feedbackState === EModalFeedbackState.LOADING) {
            return { color: theme.styles.Colors.neutral.accent, header: `Loading`, buttonSection: null };
        }
        else if (feedbackState === EModalFeedbackState.CONFIRMATION) {
            return {
                color: theme.styles.Colors.neutral.primary,
                header: `Confirm`,
                buttonSection: ((0, jsx_runtime_1.jsxs)(FelaLayers_1.FelaFlexLayer, { align: "flex-end", justify: "space-between", height: FelaLayers_1.EFelaLayerHeight.MID, padding: "0.75em", children: [(0, jsx_runtime_1.jsx)(FelaButton_1.FelaButton, { color: theme.dark ? theme.styles.Colors.lightFore.mid : theme.styles.Colors.darkFore.mid, onClick: () => {
                                // delayedState.current.message = message;
                                // delayedState.current.feedbackState = EModalFeedbackState.CONFIRMATION;
                                if (onClose) {
                                    onClose(EModalFeedbackState.CONFIRMATION, false);
                                }
                            }, margin: "0 1em 0 0", children: (0, jsx_runtime_1.jsx)("span", { className: "text", children: cancelText ?? "Cancel" }) }), (0, jsx_runtime_1.jsx)(FelaButton_1.FelaButton, { onClick: () => {
                                // delayedState.current.message = message;
                                // delayedState.current.feedbackState = EModalFeedbackState.CONFIRMATION;
                                if (onClose) {
                                    onClose(EModalFeedbackState.CONFIRMATION, true);
                                }
                            }, margin: "0", color: theme.styles.Colors.neutral.primary, children: (0, jsx_runtime_1.jsx)("span", { className: "text", children: buttonText ?? "Okay" }) })] })),
            };
        }
        return {
            color: theme.styles.Colors.neutral.primary,
            header: `Feedback`,
            buttonSection: ((0, jsx_runtime_1.jsx)(FelaLayers_1.FelaFlexLayer, { align: "flex-end", justify: "flex-end", height: FelaLayers_1.EFelaLayerHeight.MID, padding: "0.75em", children: (0, jsx_runtime_1.jsx)(FelaButton_1.FelaButton, { onClick: () => {
                        // delayedState.current.message = message;
                        // delayedState.current.feedbackState = EModalFeedbackState.ALERT;
                        if (onClose) {
                            onClose(EModalFeedbackState.ALERT, true);
                        }
                    }, margin: "0", color: theme.styles.Colors.neutral.primary, children: (0, jsx_runtime_1.jsx)("span", { className: "text", children: buttonText ?? "Okay" }) }) })),
        };
    }, [feedbackState]);
    return ((0, jsx_runtime_1.jsxs)(FelaLayers_1.FelaFlexLayer, { className: className, style: style, ...(isFloating && {
            cssExtra: [
                {
                    border: `0.1em solid rgb(${theme.dark
                        ? theme.styles.Colors.darkBack.shadow[0]
                        : theme.styles.Colors.lightBack.shadow[0]})`,
                    maxWidth: "20em",
                },
                ...cssExtra,
            ],
            extraSoftShadow: true,
            shadow: true,
        }), align: "stretch", direction: "column", children: [(0, jsx_runtime_1.jsxs)(FelaLayers_1.FelaFlexLayer, { height: FelaLayers_1.EFelaLayerHeight.LOW, cssExtra: [{ padding: "0.5em 0.75em" }], direction: "row", justify: "flex-start", align: "center", gap: 0.5, children: [(feedbackState === EModalFeedbackState.ERROR ||
                        feedbackState === EModalFeedbackState.ALERT) && ((0, jsx_runtime_1.jsx)(FelaIconWrap_1.FelaIconWrap, { color: color, noPadding: true, noBackground: true, size: VibescoutFrontendStyleConfig_1.ETextSize.small, children: (0, jsx_runtime_1.jsx)(fi_1.FiAlertTriangle, {}) })), (0, jsx_runtime_1.jsx)(FelaText_1.FelaText, { overflowWrap: "break-word", fontSize: 0.8, weight: "bold", align: "center", spacing: "0.1em", transform: "uppercase", contrast: FelaCommon_1.EGraphicContrast.MID, color: color, children: customHeader !== undefined ? customHeader : header })] }), (0, jsx_runtime_1.jsx)(FelaLayers_1.FelaFlexLayer, { padding: "0.5em 0.75em", children: (0, jsx_runtime_1.jsx)(FelaText_1.FelaText, { contrast: VibescoutFrontendStyleConfig_1.EForeContrast.extra, size: VibescoutFrontendStyleConfig_1.ETextSize.small, whiteSpace: "pre-wrap", children: message }) }), buttonSection] }));
};
exports.SimpleModalComponent = SimpleModalComponent;
